type PicGuide = {
  id: number;
  title: string;
};

export const recommended: PicGuide[] = [
  { id: 1, title: "2:3 aspect ratio" },
  { id: 2, title: "Outfit fully visible" },
  { id: 3, title: "Tight clothes" },
  { id: 4, title: "Three-quater shots" },
  { id: 5, title: "Full-body shot" },
];

export const avoid: PicGuide[] = [
  { id: 1, title: "Extreme poses or perspectives" },
  { id: 2, title: "Outfit fully visibMultiple people or kids" },
  { id: 3, title: "Hair or objects infront of clothes" },
  { id: 4, title: "Wide aspect ratio or standing far away" },
];
